import { HttpParams } from '@angular/common/http';
export class CommonUtility {

    static isNull(item: any): boolean {
        return item === undefined || item === null;
    }

    static isEmpty(item: any): boolean {
        return item === undefined || item === null
            || item.length === 0 || item === 0 || item === '' || item === 'null';
    }

    static isNotNull(item: any): boolean {
        return item !== undefined && item !== null;
    }

    static isNotEmpty(item: any): boolean {
        return item !== undefined && item !== null && item.length !== 0;
    }

    static convertObjectToParams(paramObj: object): URLSearchParams {
        const params = new URLSearchParams();
        for (const key in (paramObj || {})) {
            if (Object.prototype.hasOwnProperty.call(paramObj, key)) {
                const val = (paramObj as any)[key];
                if (Array.isArray(val)) {
                    val.forEach((k: any) => params.append(key, k));
                } else if (CommonUtility.isNotEmpty(val) && typeof val !== 'object') {
                    params.set(key, val);
                }
            }
        }
        return params;
    }

    static getParameter(paramName: string): string | null {
        const searchString = window.location.search.substring(1);
        const params = searchString.split('&');
        for (const param of params) {
            const val = param.split('=');
            if (val[0] === paramName) return val[1];
        }
        return null;
    }

    static convertObjectToUrlEncoded(paramObj: { [key: string]: any }): HttpParams {
        let params = new HttpParams();
        for (const key in paramObj) {
            if (Object.prototype.hasOwnProperty.call(paramObj, key) && paramObj[key]) {
                params = params.append(key, paramObj[key]);
            }
        }
        return params;
    }
}
